import { render, staticRenderFns } from "./MajorShareholders.vue?vue&type=template&id=36c1bce2"
import script from "./MajorShareholders.vue?vue&type=script&lang=js"
export * from "./MajorShareholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports